export default {
  slices: [
    {
      field: 'ad_type',
      display: 'Ad Type',
      map: {
        'tv_outlined': {
          display: 'TV',
          sortOrder: 1
        },
        'olv': {
          display: 'Online Video',
          sortOrder: 2
        }
      }
    },
    {
      field: 'market',
      display: 'Market',
      map: {
        'general_market': {
          display: 'General Market',
          sortOrder: 1
        },
        'hispanic_market': {
          display: 'Hispanic Market',
          sortOrder: 2
        }
      }
    },
    {
      field: 'ad_categories',
      display: 'Ad Category',
      variant: 'multigroup',
      map: {
        'all_wireless_internet': {
          display: 'All Wireless & Home Internet',
          sortOrder: 1,
          multigroup: true,
          groupName: 'Tmobile',
        },
        'postpaid_wireless_internet': {
          display: 'Postpaid Wireless & Home Internet',
          sortOrder: 2,
          multigroup: true,
          groupName: 'Tmobile',
        },
        'total_wireless': {
          display: 'Total Wireless',
          sortOrder: 3,
          multigroup: true,
          groupName: 'Tmobile',
        },
        'wireless_prepaid': {
          display: 'Wireless - Prepaid',
          sortOrder: 4,
          groupName: 'Tmobile',
        },
        'wireless_postpaid': {
          display: 'Wireless - Postpaid',
          sortOrder: 5,
          groupName: 'Tmobile',
        },
        'internet': {
          display: 'Home Internet',
          sortOrder: 6,
          groupName: 'Tmobile',
        }
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./src/app/configuration/Tmobile/config/metadata.js